import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { CardListConfig } from '@rappider/rappider-components';

@Component({
  selector: 'rappider-textarea-input-with-options',
  standalone: true,
  imports: [CommonModule, FormsModule, NzInputModule, NzButtonModule, NzDropDownModule],
  templateUrl: './textarea-input-with-options.component.html',
  styleUrls: ['./textarea-input-with-options.component.scss']
})
export class TextareaInputWithOptionsComponent {
  // @Input() activeFeature: any;
  // @Output() messageSent = new EventEmitter<string>();

  inputText = '';

  onKeyPress(event: KeyboardEvent): void {
    // Handle Cmd+Enter or Ctrl+Enter to start
    if (event.key === 'Enter' && (event.metaKey || event.ctrlKey)) {
      event.preventDefault();
      this.onStart();
    }
  }

  onStart(): void {
    if (this.inputText.trim()) {
      console.log('Starting with prompt:', this.inputText);
      // Add your implementation here
    }
  }
}
